import * as React from 'react'

import SitemapAttributeTag from '~/client/src/shared/components/SitemapAttributeTag/SitemapAttributeTag'
import LocationAttributeBase from '~/client/src/shared/models/LocationObjects/LocationAttributeBase'
import { ITag } from '~/client/src/shared/models/Tag'
import { NO_VALUE } from '~/client/src/shared/utils/usefulStrings'

const MAX_VISIBLE_TAGS = 2

interface ITagListCellProps {
  readonly tags: readonly ITag[]
}

export default function TagListCell({
  tags,
}: ITagListCellProps): React.ReactElement {
  if (!tags.length) return <>{NO_VALUE}</>

  const hiddenCount = tags.length - MAX_VISIBLE_TAGS

  return (
    <div
      className="tw:flex tw:min-w-0 tw:items-center tw:gap-1"
      title={tags.map(tag => tag.name).join(', ')}
    >
      {tags.slice(0, MAX_VISIBLE_TAGS).map(tag => (
        <span key={tag.id + tag.type} className="tw:flex tw:min-w-0">
          <SitemapAttributeTag
            dataObject={tag as LocationAttributeBase}
            contentContainerClassName="tw:truncate tw:py-0.5"
            shouldShowAsTag
          >
            <span>{tag.name}</span>
          </SitemapAttributeTag>
        </span>
      ))}
      {hiddenCount > 0 && (
        <span className="tw:shrink-0">{`(+${hiddenCount})`}</span>
      )}
    </div>
  )
}
